import { CategoriaEsame } from '@hm_app/@core/models/esame';
import { Distretto, AreaVasta } from '@hm_app/@core/models/anagrafica_geo';
import { Component, OnInit } from '@angular/core';
import { Provincia, Comune } from '@hm_app/@core/models/anagrafica_geo';
import * as _ from 'lodash-es';
import { Struttura, TipologiaStruttura, TipoServizioStruttura } from '@hm_app/@core/models/struttura';
import { Router } from '@angular/router';
import { Esame } from '@hm_app/@core/models/esame';
import { Utente } from '@hm_app/@core/models/utente';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';

@Component({
    selector: 'ngx-strutture',
    templateUrl: './strutture.component.html',
    styleUrls: ['./strutture.component.scss'],
})
export class StruttureComponent implements OnInit {

    province: Provincia[];
    province_toscane: Provincia[];
    comuni: Comune[];
    comuni_filtered: Comune[];
    strutture: Struttura[];
    tipologie_struttura: TipologiaStruttura[];
    distretti: Distretto[];
    tipi_serv_strut: TipoServizioStruttura[];
    aree_vaste: AreaVasta[];
    esami: Esame[];
    categorie_esami: CategoriaEsame[];

    _utente: Utente;

    constructor(private service: HappyMammaService, private router: Router) {

    }

    set utente(u: Utente) {
        this._utente = u;
    }

    get utente(): Utente {
        return this._utente;
    }


    async getUtente() {
        if (!this.service.auth_user) {
            return;
        }

        try {
            const profilo = await this.service.getCurrentUserProfile();
            this.utente = profilo.utente;
        } catch (e) {
            const exception = e;
            console.error(e);
            if (exception.status == 406 || exception.status == 401) {
                this.router.navigate(['/auth/login']);
            }
        }
    }

    async ngOnInit() {
        await this.getUtente();

        this.esami = await this.service.esamiAllPromise();
        this.categorie_esami = await this.service.categoriaEsameAllPromise();

        this.esami = await this.service.esamiAllPromise();
        this.categorie_esami = await this.service.categoriaEsameAllPromise();
        this.categorie_esami = await this.service.categoriaEsameAllPromise();

        this.province = await this.service.provinceAllPromise();
        this.province_toscane = await this.service.provinceToscanaAllPromise();
        this.comuni = await this.service.comuniAllPromise();

        this.strutture = await this.service.struttureAllPromise();
        this.distretti = await this.service.distrettiWithMacrozonaPromise();

        // this.service.getServiziStrutture().subscribe(servizi_strutture => { this.servizi_strutture = servizi_strutture })
        // this.servizi_strutture = await this.service.serviziStruttureAllPromise();

        // this.service.getOrariStrutture().subscribe(orari_strutture => { this.orari_strutture = orari_strutture })
        // this.orari_strutture = await this.service.oraritruttureAllPromise();

        this.tipi_serv_strut = await this.service.tipoServizioStrutturaAllPromise();
        this.aree_vaste = await this.service.areeVasteAllPromise();
    }

}
